import Vue from 'vue';
import Vuex from 'vuex';
import flow from '@/components/packages/store/index';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    flow,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/storeProcess/index.js